import { trpc } from '@/shared/api';

/** 열 때마다(마운트마다) 다시 불러 개인정보 조회 기록을 남긴다 — 목록에서 미리 불러오지 않고, 창을 다시 보는 것만으로는 부르지 않는다. */
export const useOrderInquiryDetailQuery = (inquiryId: string) =>
  trpc.orderInquiryManagement.get.useQuery(
    { inquiryId },
    {
      staleTime: Number.POSITIVE_INFINITY,
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
    },
  );
